import {AjaxGet,AjaxPost} from './Ajax';
import constants from './constants/index';

export default {
    getData: (data) => AjaxPost(constants.getData, data),//获取JSON数据
    saveData: (data) => AjaxPost(constants.saveData, data),//保存JSON数据
}